import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort-up",
  "use": "icon-sort-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sort-up\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 16h16V0H0z\" />\n        <path d=\"M8.787 1.16h1.243l5.233 5.231-2.254.009-4.222-4.114V1.159zm-.053 2.12 1.6 1.6v9.92h-1.6V3.28zM.8 1.2h6.4v1.6H.8V1.2zm.8 4h5.6v1.6H1.6V5.2zm.8 4h4.8v1.6H2.4V9.2zm.8 4h4v1.6h-4v-1.6z\" fill=\"#000018\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol